// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from './utils'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Print from 'vue-print-nb'
import 'iview/dist/styles/iview.css'
import './iconfont/iconfont.css'
import store from './store'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuelidate from 'vuelidate'
import * as rules from 'vuelidate/lib/validators'
// import VueI18n from 'vue-i18n'
import {i18n} from './language/index'
// import htmlToPdf from '@/utils/htmlToPdf'
// import {
//   api
// } from './api'
// Vue.use(htmlToPdf)
Vue.prototype.$rules = {}
Object.keys(rules).forEach(key => {
  Vue.prototype.$rules[key] = rules[key]
})
Vue.use(Vuetify)
Vue.use(Print)
Vue.use(ElementUI)
Vue.use(Treeselect)
Vue.use(Vuelidate)
// Vue.use(VueI18n)
Vue.config.productionTip = false

Vue.prototype.$u = utils
// Vue.prototype.$api = api

// aixos
const vuelidateRule = {
  id_is: (value) => {
    return value !== 'bmgjh0on793g00835fhg' && value !== 'bmgjh0on793g00835fhg'
  }
}
export default vuelidateRule
export const http = axios.create({
  // baseURL: process.env.BASE_API,
  // baseURL: 'http://oauth.aks.hscloud.top/api/',
  timeout: 10000, // request timeou// t
  // withCredentials: true,
  // headers: {
  //   'Conten-Type': 'application/x-www-form-urlencoded'}
})


// 增加请求拦截器
http.interceptors.request.use(function (config) {
  // deal token
  if (config.method === 'post' || config.method === 'put') {
    if(config.data) {
      config.data.token = localStorage.getItem('cors')
    } else {
      config.data = {
        token: localStorage.getItem('cors')
      }
    }
  }
  let token = utils.storage.get_token()
  if (token) {
    console.log(token, 'ytokenyyy')
    config.headers.common['Authorization'] = 'Bearer ' + token
  }

  return config
}, function (error) {
  console.log('request error:', error)
  return Promise.reject(error)
})

// 增加一个response拦截器
http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let routeName = router.app._route.name
  let res = error.response
  if (res && res.status === 401) {
    // $message.warning("验证失败,您可能未登录或没有权限");
    if (routeName !== '') {
      router.push({
        name: 'login',
        query: {
          next: routeName
        }
      })
    } else {
      router.push({
        name: 'login'
      })
    }
  }

  return Promise.reject(error)
})

export let apiObj = (obj) => {
  let url = ''
  for (let key in obj) {
    if (url.indexOf('?') === -1) {
      url += '?' + key + '=' + obj[key]
    } else {
      url += '&' + key + '=' + obj[key]
    }
  }
  return url
}

Vue.prototype.$h = http

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js